import { render, staticRenderFns } from "./StudentExam.vue?vue&type=template&id=53cc2d6b&scoped=true"
import script from "./StudentExam.vue?vue&type=script&lang=js"
export * from "./StudentExam.vue?vue&type=script&lang=js"
import style0 from "./StudentExam.vue?vue&type=style&index=0&id=53cc2d6b&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53cc2d6b",
  null
  
)

export default component.exports